exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-wrap[data-v-4aad0160]{display:-webkit-box;display:-ms-flexbox;display:flex;background:#fcfcfc;border:1px solid #eaeaea;padding:5px;border-radius:2px}.content-wrap .wrap-h[data-v-4aad0160]{width:150px;height:94px;background-size:cover;background-position:50%;border-radius:2px}.content-wrap .wrap-f[data-v-4aad0160]{-webkit-box-flex:1;-ms-flex:1;flex:1;margin-top:8px;margin-left:5px;line-height:1.4em;height:4.2em;font-size:16px}", ""]);

// exports
